import { render, staticRenderFns } from "./AccountSet.vue?vue&type=template&id=5fa4d2b8&scoped=true&"
import script from "./AccountSet.vue?vue&type=script&lang=js&"
export * from "./AccountSet.vue?vue&type=script&lang=js&"
import style0 from "./AccountSet.vue?vue&type=style&index=0&id=5fa4d2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4d2b8",
  null
  
)

export default component.exports